<template>
  <div>
    <div class="h400">
      <div class="logimg">SEEONCE</div>
      <div class="container">
        <div class="lefts">
          <p class="p1">DAT产教融合精品课堂</p>
          <p style="margin-top: 1rem;" class="p2">用数据驱动课堂教学改进 </p>
          <p class="p2">更快，更好，更简</p>
          <img class="login-graphic"  src="../../../static/img/login-graphic.png">
        </div>
        <div v-if="isForgetpassword==false" class="loginbox">
          <div class="tops">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="密码登录" name="first">
                <el-form
                  style="margin-top:1.5rem"
                  :label-position="labelPosition"
                  label-width="80px"
                  :model="formLabelAlign"
                >
                  <el-form-item label="手机号码">
                    <el-input placeholder="请输入手机号码" v-model="iphone"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-top:2.5rem" label="密码">
                    <el-input placeholder="请输入密码" type="password" v-model="password"></el-input>
                  </el-form-item>
                </el-form>

              <div @click="login(1)" class="loginbtn">登录</div>
              </el-tab-pane>
              <el-tab-pane label="短信登录" name="second">
                <el-form
                  style="margin-top:1.5rem"
                  :label-position="labelPosition"
                  label-width="80px"
                  :model="formLabelAlign"
                >
                  <el-form-item :error='inputError' label="手机号码">
                    <el-input  placeholder="请输入手机号码" v-model="iphone"></el-input>
                  </el-form-item>
                  <div v-if="inputError" class="errorred">该账号不存在，请重新输入！</div>
                  <div class="yzm">验证码</div>
                  <div class="sercenbox">
                    <div>
                      <el-input placeholder="请输入4位数字" v-model="code" style="width:12.875rem; margin-left:0"></el-input>
                    </div>
                    <div @click="getmessage(1)" class="dxbtn">{{magws}}</div>
                  </div>
                </el-form>

                <div @click="login(2)" class="loginbtn">登录</div>
              </el-tab-pane>
            </el-tabs>
            <el-checkbox size="30px" style="float:left; margin-top:2rem" v-model="checked">下次自动登录</el-checkbox>
            <div @click="Forgetpassword()" class="fotpassword">忘记密码</div>
          </div>
        </div>

        <div class="loginbox" v-if="isForgetpassword==true">
          <div class="tops">
            <div class="repasw">重置密码</div>
            <div class="sen">为了您的账户安全，请先进行安全校验</div>
            <div class="barboder"></div>
            <el-form
              style="margin-top:1.5rem"
              :label-position="labelPosition"
              label-width="80px"
              :model="formLabelAlign"
            >
              <el-form-item :error='inputError' label="手机号码">
                <el-input placeholder="请输入手机号码" v-model="iphone"></el-input>
              </el-form-item>
            </el-form>
<!-- <div  v-if="inputError" class="errorred">请输入正确的手机号码！</div> -->
            <div class="yzm">验证码</div>
            <div class="sercenbox">
              <div>
                <el-input placeholder="请输入4位数字"   style="width:12.875rem; margin-left:0"></el-input>
              </div>
              <div @click="getmessage(2)" class="dxbtn">{{magws}}</div>
            </div>

            <div @click="nextt" class="loginbtn">下一步</div>

            <div class="bottoms">
              <span @click="Forgetpassword(1)">密码登录</span>
              <span>|</span>
              <span @click="Forgetpassword(2)">短信登录</span>
            </div>
          </div>
        </div>

        <div class="loginbox" v-if="Reset==true">
          <div class="tops">
            <div class="repasw">重置密码</div>
            <div class="sen">为了您的账户安全，请先进行安全校验</div>
            <div class="barboder"></div>
            <el-form
              style="margin-top:1.5rem"
              :label-position="labelPosition"
              label-width="80px"
              :model="formLabelAlign"
            >
              <el-form-item label="新密码">
                <el-input  type="password" placeholder="请输入新密码(至少6位数字或字符)" v-model="password1"></el-input>
              </el-form-item>
               <el-form-item label="确认密码">
                <el-input  type="password" placeholder="再次输入新密码" v-model="password"></el-input>
              </el-form-item>
            </el-form>

         

            <div @click="confirmr" class="loginbtn">确认</div>

            <div class="bottoms">
              <span @click="Forgetpassword(1)">密码登录</span>
              <span>|</span>
              <span @click="Forgetpassword(2)">短信登录</span>
            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/tool/bus";
import hint from "@/components/component/hint";
export default {
  name: "index",
  components: {
    hint,
  },
  data() {
    return {
      activeName: "first",
      labelPosition: "top",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      isForgetpassword:false,
      password:'',
      checked: true,
      iphone: "",
      erorser: true,
     code:'',
     Reset:false,
     iphone1:'',
     inputError:false,
     magws:'获取验证码',
     miao:60,
     interval:'',
    };
  },
 
  computed: {
  },
  mounted() {},
methods: {
login(id){
  var password="";
  if(id==1){
    password=this.password
  }else {
     password=this.code
  }
    this.axios({
          method: "post",
          url: this.url + "/teacher/auth/login",
          data: {
           type:id,
            "mobile":this.iphone ,
            "password": password
          },
        }).then((res) => { 
          if (res.data.status == 200) {
             this.$message.success(res.data.message);
             localStorage.setItem("token",res.data.access_token);
             localStorage.setItem("refresh_token",res.data.refresh_token);
              setTimeout(()=>{  
                this.$router.push({
                path: "/index",
            });},500)
           
          } else {
            this.$message.error(res.data.message);
          }
        });
},
    avatarError(e) {
        //头像图片错误替换
       e.target.src = require("../../../static/img/default_avatar.jpg");
    },
    Forgetpassword(id) {
      this.iphone='';
      this.password='';
      this.code="";
      this.inputError=false;
       window.clearInterval(this.interval);
       this.miao=60;
       this.magws='获取验证码';
      this.isForgetpassword = !this.isForgetpassword;
      if (id == 1) {
        this.activeName = "first";
      } else if (id == 2) {
        this.activeName = "second";
      } else {
        this.activeName = "first";
      }
    },
     handleClick(tab, event) {
        this.iphone='';
      this.password='';
      this.code="";
       if(this.activeName=='first')
       {
          window.clearInterval(this.interval);
          this.miao=60;
            this.magws='获取验证码';
       }
       
      },
    //获取短信验证码
    getmessage(id) {
    var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
      if (!myreg.test(this.iphone)) {
         this.inputError=true;
          if(id==2)
          {
             this.$message.error("请输入正确的手机号码") 
          }
           setTimeout(()=>{
               this.inputError=false;
              
             },2500)
        return false;
      }else{
         if(this.miao==60){
         
        this.interval= setInterval(() => {
             this.magws=this.miao+'(s)';
             if(this.miao>=0)
             {
               this.miao--;
             }else{
               this.miao=60;
               window.clearInterval(this.interval);
               this.magws="获取验证码"
             }
            

          }, 1000) 
      }
         var resetPass1='login'
    if(id==1){
       resetPass1='login'
    }else{
       resetPass1='resetPass'
    }
         this.inputError=false;
        this.axios({
          method: "post",
          url: this.url + "/tool/sms/send",
          data: {
          role: "teacher",
          type: resetPass1,
          mobile:this.iphone
          },
        }).then((res) => {
          if (res.data.status == 200) {
             this.$message.success(res.data.message);
            window.clearInterval(this.interval);
            this.miao=60;
            this.magws='获取验证码';
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
     
    },
    nextt(){
       var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
      if(myreg.test(this.iphone))
      {
     if(this.code.length==4)
      {
       this.Reset=true;
       this.isForgetpassword='f'
      }else{
         this.$message.error("请输入正确的短信验证码")
      }
      }else{
         this.$message.error("请输入正确的手机号码")
      }
     
  window.clearInterval(this.interval);
 this.miao=60;
 this.magws='获取验证码';
    },
    //重置密码
    confirmr(){
      if(this.password.length<6)
      {
        this.$message.error('密码至少要6位数');
        return;
      }
      if(this.password===this.password1)
      {
           this.axios({
          method: "post",
          url: this.url + "/tool/account/resetPass",
          data: {
          password: this.password,
          role:'teacher',
          mobile:this.iphone,
          code:this.code
         
          },
        }).then((res) => {
          if (res.data.status == 200) {
            this.isForgetpassword=false;
             this.$message.success(res.data.message);
            window.clearInterval(this.interval);
            $this.$routerrouter.go(0)
          } else {
            this.$message.error(res.data.message);
          }
        });
      }else{
         this.$message.error('两次输入的密码不一致，请重新输入');
      }

    }
  },
  created() {},
  mounted() {
    // alert(2);
    // console.log(this.$refs.refLoading.ann());
  },
  destroyed() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.h400 {
  // height: 58.25rem;
  width: 100%;
  background-image: url(../../../static/img/bg.png);
  background-size: 100% 100%;
}
.logimg {
  height: 2rem;
  text-align: left;
  font-size: 1.6rem;
  color: #fff;
  margin-left: 2.5rem;
  padding-top: 1.75rem;
}
.container {
  display: flex;
  justify-content: center;
  font-size: 0.875rem /* 14/16 */;
  margin-top: 9rem;
}
.lefts {
  color: #fff;
  text-align: left;
  .p1 {
    font-size: 2.5rem;
  }
   .p2 {  
   
font-size: 1rem;
font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
font-weight: 500;
line-height: 1.7rem;
  }
 
}
.loginbox {
  width: 31.25rem;
  height: 33.75rem;
  background: #ffffff;
  box-shadow: 0px 20px 15px -15px rgba(0, 55, 110, 0.1);
  border-radius: 8px;
  margin-left: 10rem;
}
.passwordlogin {
  font-size: 1.5rem;
  font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
  font-weight: bold;
  color: #000000;
}
.tops {
  margin-top: 2rem;
  width: 80%;
  margin-left: 10%;
}
.messagelogin {
  color: #7e8491;
  margin-left: 2.5rem;
}
/deep/ .el-tabs__item.is-active {
  color: #000000;
  font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
  font-weight: bold;
  font-size: 1.5rem;
}
/deep/.el-tabs__item {
  font-size: 1.5rem;
}
/deep/ .el-tabs__active-bar {
  background-color: #000000;
  height: 0.205rem;
}
/deep/ .el-form-item__label {
  float: left;
  line-height: 1rem;
}
/deep/.el-input__inner {
  height: 3.5rem;
}
.loginbtn {
  width: 24.25rem;
  height: 3.5rem;
  background: #40c3c4;
  border-radius: 0.25rem;
  line-height: 3.5rem;
  font-size: 1.25rem;
  font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
  font-weight: bold;
  color: #ffffff;
  margin-top: 3rem;
  margin-left: 0.5rem;
  cursor: pointer;
}
/deep/.el-checkbox__label {
  font-size: 1.25rem;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #7e8491;
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input .el-checkbox__inner {
  background-color: #40c3c4;
  border-color: #40c3c4;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #7e8491;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #40c3c4;
}
/deep/.el-form-item__label {
  font-size: 1.25rem;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #7e8491;
}
.fotpassword {
  font-size: 1.25rem;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #7e8491;
  float: right;
  margin-top: 1.5rem;
  cursor: pointer;
}
.errorred {
  font-size: 1rem;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: #f33845;
  line-height: 0.5rem;
  text-align: left;
  margin-top: -1rem;
}
.yzm {
  font-size: 1.25rem;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #7e8491;
  text-align: left;
  margin-top: 1rem;
  line-height: 2rem;
}
.dxbtn {
  width: 10.625rem;
  height: 3.2rem;
  border-radius: 0.25rem;
  border: 2px solid #40c3c4;
  line-height: 3.2rem;
  font-size: 1.25rem;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #40c3c4;
  margin-left: 0.7125rem;
  cursor: pointer;
}
.sercenbox {
  display: flex;
  justify-content: center;
}
.repasw {
  font-size: 1.5rem;
  font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
  font-weight: bold;
  color: #000000;
  text-align: left;
}
.sen {
  text-align: left;
  font-size: 1.125rem;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: #363636;
  margin-top: 1rem;
}
.barboder {
  border: 1px solid #ccd0d6;
  margin-top: 2rem;
  width: 100%;
}
.bottoms {
  margin-top: 1.5rem;
  font-size: 1.25rem;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #7e8491;
  span {
    margin-left: 0.5rem;
    cursor: pointer;
  }
}
.login-graphic{
  width: 31.375rem;
}
/deep/ .el-form-item__error{
  opacity: 0;
}
/deep/.el-tabs__item:hover {
    color: #40c3c4;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/login/login.vue